import Api from "@/services/Api";
import axios from "axios";


export async function socialLogin(provider) {
    return await Api().get(`/oauth/${provider}`);
}

export async function getCategories() {
    return await Api().get("/travel/categories");
}

export async function login(credentials) {
    await axios({
        method: "GET",
        headers: { "Content-Type": "application/json", Accept: "application/json", },
        url: "/sanctum/csrf-cookie",
        baseURL: "/",
    });

    return axios({
        method: "post",
        headers: { "Content-Type": "application/json", Accept: "application/json", },
        url: "/login",
        data: credentials,
        baseURL: "/",
    });
}

export async function forgetpassword(credentials) {
    await axios({
        method: "GET",
        headers: { "Content-Type": "application/json", Accept: "application/json", },
        url: "/sanctum/csrf-cookie",
        baseURL: "/",
    });

    return axios({
        method: "post",
        headers: { "Content-Type": "application/json", Accept: "application/json", },
        url: "/forgot-password",
        data: credentials,
        baseURL: "/api/v1",
    });
}

export async function sendVerificationEmail() {
    await axios.get("/sanctum/csrf-cookie");
    return axios({
        method: "post",
        url: "/email/verification-notification",
        baseURL: "/",
    });
}

export async function logoutSession() {
    await axios.get("/sanctum/csrf-cookie");
    return await axios({
        method: "post",
        headers: {
            Accept: "application/json",
        },
        url: "/logout",
        baseURL: "/",
    });
}
export async function updateVerificationEmail(email='') {
    return await Api().post(`/auth/verification-email/update`,{email:email});
}

export async function oAuthLogin(provider) {
    await axios({
        method: "GET",
        headers: { "Content-Type": "application/json", Accept: "application/json", },
        url: "/sanctum/csrf-cookie",
        baseURL: "/",
    });

    return await Api().get(`/oauth/${provider}`);
}

export async function switchAgency(payload) {
    return await Api().post("/switch-agency", payload);
}
